import { Card, CardContent, makeStyles } from "@material-ui/core";
import { FC } from "react";

type ResizableCardProps = {
  title: string;
  children: React.ReactNode;
  height?: string | number; // Optional height prop
};

const useStyles = makeStyles(() => ({
  outer: {
    width: '100%',
    padding: 8,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
  },
  card: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  content: {
    flex: 1,
    overflow: 'auto',
    padding: 16,
  },
}));

const ResizableCard: FC<ResizableCardProps> = ({ title, children, height = '100%' }) => {
  const classes = useStyles();

  return (
    <div className={classes.outer} style={{ height }}>
      <Card elevation={2} className={classes.card}>
        <CardContent className={classes.content}>
          <h3 style={{ marginTop: 0 }}>{title}</h3>
          {children}
        </CardContent>
      </Card>
    </div>
  );
};

export default ResizableCard;
